<template>
    <div class="JWvideoHandler">
        <div id='player'></div>
<!--        <div id='master-wrapper'>-->
<!--            <div id='player'></div>-->
<!--            <div id='playlist'></div>-->
<!--        </div>-->
<!--        <transition name="fade" v-if="showButtonFlag">-->
<!--            <button @click="redirectUserToJoin" id="buyflow" class="pink-button" v-if="showButtonFlag" :style="{'border-width': '1px !important', 'border-style': 'solid !important', 'border-color': this.getCorpButtonColor + ' !important', 'color': '#FFFFF !important', 'background-color': this.getCorpButtonColor + ' !important' }">Join Now</button>-->
<!--        </transition>-->
<!--        <transition name="fade" v-if="becomeMemberFlag">-->
<!--            <button @click="redirectUserToCompleteSignup" id="becomeMemberflow" class="pink-button" v-if="becomeMemberFlag">Update my Membership</button>-->
<!--        </transition>-->
    </div>
</template>

<script>
    import store from '../store'
    import { mapGetters } from 'vuex'
    // import { dateHelpers } from '../helpers/dateHelpers.js'
    export default {
        props: ['data', 'onComplete', 'onPlaylistItem', 'onPlaylistComplete'],
        name: 'jwplayerplaylistplayer',
        data: function () {
            return {
                playerID: Math.floor(Math.random() * 1000000),
                isMute: false,
                autoStartVideo: true,
                duration: 0,
                directedFromAuthenticatedPage: false,
                repeat: false,
                showButtonFlag: false,
                showNativeFlag: false,
                becomeMemberFlag: false,
                tonePlaylistJSON: null
            }
        },
        methods: {
            redirectUserToJoin () {
                if (navigator.userAgent.indexOf('gonative') > -1) { // Native app
                    this.$router.push('/joinnative')
                } else { // regular user
                    this.$router.push('/signup')
                }
            },
            redirectUserToCompleteSignup () {
                this.$router.push('/becomemember')
            }
        },
        mounted () {
            var self = this
            self.tonePlaylistJSON = [
                {
                    'image': 'https://cdn.jwplayer.com/v2/media/GECNkWxo/poster.jpg?width=720',
                    'videoCode': 'GECNkWxo',
                    'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
                    'description': 'As women, we approach money from one of three perspectives: happiness, fear, or commitment. Find out which one is your money mind and what it all means with this financially savvy video.',
                    'title': 'Whats Your Money Mind?'
                },
                {
                    'image': 'https://cdn.jwplayer.com/v2/media/gtZ2dSz0/poster.jpg?width=720',
                    'videoCode': 'gtZ2dSz0',
                    'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
                    'description': 'Earn your seat at the table by putting forth the best version of yourself. Make your voice heard with the tips in this video.',
                    'title': 'Getting a Seat at the Table'
                },
                {
                    'image': 'https://cdn.jwplayer.com/v2/media/XZjZQx5o/poster.jpg?width=720',
                    'videoCode': 'XZjZQx5o',
                    'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
                    'description': 'Its important to let your kids know you are proud of them. But did you know that its possible to go overboard on the praise? Let Dr. Tracy Alloway teach you the best ways to praise your kids to encourage real growth and effort in this video.',
                    'title': 'Praising Your Kids'
                },
                {
                    'image': 'https://cdn.jwplayer.com/v2/media/4Q8FbuHP/poster.jpg?width=720',
                    'videoCode': '4Q8FbuHP',
                    'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
                    'description': 'Are you always hungry, no matter what you eat? It may be time to examine your diet and talk to a doctor to find out if you have insulin resistance. Traci Fields has the advice you need on managing insulin resistance so you can fight hunger the healthy way.',
                    'title': 'Always Hungry?'
                }]
            let lastPosition = 0
            let player = window.jwplayer('player').setup({
                playlist: self.data,
                autostart: true,
                stretching: 'uniform',
                //  autostart: true,
                width: '100%',
                events: {
                    onReady: function (state) {
                        // let playlist = window.jwplayer().getPlaylist()
                        // console.log('playlist', playlist)
                        // for (let i = 0; i < playlist.length; i++) {
                        //     document.getElementById('playlist').innerHTML += `
                        //        \t\t\t\t\t<div class='playlist-item' onclick='jwplayer().playlistItem(${i})'>
                        //        \t\t\t\t\t\t<img src='${playlist[i].image}' alt='${playlist[i].title}'/>
                        //        \t\t\t\t\t\t<p>${playlist[i].title}</p>
                        //         \t\t\t\t\t</div>`
                        // }
                    },
                    onPlaylistItem: function (item) {
                        console.log('JwPlaylistTemp -> onPlaylistItem: --------- > item changed in playlist - Item', item)
                        store.commit('setItemChangeInPlaylist', {item: item})
                    },
                    onComplete: (state) => {
                        console.log('JwPlaylistTemp -> onComplete: --------- > user watched full video', state)
                    },
                    onPlaylistComplete: () => {
                        console.log('JwPlaylistTemp -> onPlaylistComplete: --------- > whole playlist has completed')
                        this.$router.push('/profile/playlist')
                    },
                    onTime: function (state) {
                        // For user last position
                        // console.log('JwPlaylistTemp -> onTime: --------- >1  state = ', state) commented because fills log
                        let currentPosition = Math.floor(this.getPosition())
                        let totalDuration = Math.floor(this.getDuration())
                        // Show buy button before 3 seconds of video
                        if (totalDuration - currentPosition <= 5 && self.user && self.currentRoute.name === 'Player' && self.user.trialEndDate !== null && (self.$route.params.refBy.toLowerCase() === 'toneteaser' || self.$route.params.refBy.toLowerCase() === 'tonetakeaway')) {
                            this.setFullscreen(false)
                            self.becomeMemberFlag = true
                        } else {
                            self.becomeMemberFlag = false
                        }
                        // console.log('JwPlaylistTemp -> onTime: --------- >2  totalDuration = ', totalDuration)
                        if (totalDuration - currentPosition <= 3 && !self.user && self.currentRoute.name !== 'UnAuth' && self.currentRoute.name !== 'B2b') {
                            this.setFullscreen(false)
                            self.showButtonFlag = true
                        } else {
                            self.showButtonFlag = false
                        }
                        // console.log('JwPlaylistTemp -> onTime: --------- >3  currentPosition = ', currentPosition)
                        // console.log('JwPlaylistTemp -> onTime: --------- >4  lastPosition = ', lastPosition)
                        if (currentPosition <= totalDuration && lastPosition !== currentPosition) {
                            console.log('JwPlaylistTemp -> onTime: --------- >4 (store.commit(\'setCurrentVideoDurationWatched) currentPosition = ', currentPosition)
                            store.commit('setCurrentVideoDurationWatched', {duration: currentPosition})
                            // console.log('JwPlaylistTemp -> onTime: --------- >3  setCurrentVideoDurationWatched() EXECUTED : currentPosition = ', currentPosition)
                        }
                        lastPosition = currentPosition
                        // console.log('JwPlaylistTemp -> onTime: --------- >3  totalDuration = ', totalDuration)
                    }
                }
            })
            console.log('JwPlaylistTemp --------- > player object', player)
        },
        computed: {
            ...mapGetters([
                'user', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor'
            ]),
            currentRoute () {
                //  console.log('route', this.$route)
                //  console.log('route', this.$route.name)
                //  if (this.$route.name === 'Redeem,') {
                //      console.log('yes')
                //  }
                return this.$route
            }
        }
    }
</script>
<style scoped>
    .JWvideoHandler>button.pink-button {
        position: absolute;
        z-index: 100;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
        color: white;
        font-size: 16px;
        border: none;
        width: 253px;
        padding: 14px 15px 12px;
        border-radius: 3px;
        background: rgb(240, 97, 125) !important;
        text-transform: uppercase !important;
        letter-spacing: 1px !important;
    }

    .JWvideoHandler {
        position: relative;
    }
    .jwplayer.jw-flag-fullscreen+button {
        position: fixed;
        z-index: 999999999999999999;
    }

    @media(max-width:1024px) {
        .JWvideoHandler {
            width: 100%;
            display: table;
        }
    }
    @media(max-width:767px){
        .JWvideoHandler>button.pink-button {
            font-size: 14px;
            border: none;
            width: auto;
            padding: 8px 10px 5px;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @media(min-width:1350px){
        .JWvideoHandler>button.pink-button{
            bottom:15%;
        }
    }
    /* #master-wrapper {*/
    /*     display: flex;*/
    /*     flex-direction: row;*/
    /*     justify-content: center;*/
    /* }*/
    /*#playlist {*/
    /*    width: 360px;*/
    /*    height: 360px;*/
    /*    background-color: black;*/
    /*    overflow: scroll;*/
    /*}*/
    /*.playlist-item {*/
    /*    width: calc(100% - 20px);*/
    /*    height: auto;*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    align-items: center;*/
    /*    justify-content: flex-start;*/
    /*    font-family: sans-serif;*/
    /*    color: white;*/
    /*    padding: 5px 10px;*/
    /*    cursor: pointer;*/
    /*}*/
    /*.playlist-item img {*/
    /*    height: 100px;*/
    /*    display: inline-block;*/
    /*    margin-right: 10px;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// JwPlayListTemp.vue?b552b758